import React from 'react';

import { useHistory } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import * as S from './styles';

const RawMaterial: React.FC = () => {
  const { rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  return (
    <S.Container>
      <div className="header">
        <h1>Matérias-Primas</h1>
        <p>
          Aqui você pode criar e editar seus grupos e produtos de{' '}
          <span>matérias primas</span>.
        </p>
      </div>
    </S.Container>
  );
};

export default RawMaterial;
